import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";

const SupervisoraServicios = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const usuario = user?.user || user || "";

  return (
    <div style={{ ...styles.container, position: "relative" }}>
      <div style={{ position: "absolute", top: 12, left: 12, zIndex: 50 }}>
        <button onClick={() => navigate("/supervisora")} style={styles.btnVolver}>
          ← Volver
        </button>
      </div>

      <h1 style={styles.title}>
        🧹🧼 Servicios — <strong style={{ color: "#007bff" }}>{usuario}</strong>
      </h1>

      <div style={styles.buttonContainer}>
        <button
          onClick={() => navigate("/supervisora/ruta")}
          style={{ ...styles.button, border: "2px solid #0d9488" }}
        >
          <span style={{ ...styles.image, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48 }}>🗺️</span>
          <span style={{ ...styles.label, color: "#0d9488" }}>Mi Ruta</span>
        </button>
        <button
          onClick={() => navigate("/supervisora/pisoOrganizarServicios")}
          style={styles.button}
        >
          <img src="/images/organizar-servicios.png" alt="Organizar servicios" style={styles.image} />
          <span style={styles.label}>Organizar servicios</span>
        </button>
        <button
          onClick={() => navigate("/supervisora/reporte-asistentas")}
          style={styles.button}
        >
          <img src="/images/reporte-asistentas.jpg" alt="Reporte de asistentas" style={styles.image} />
          <span style={styles.label}>Reporte de asistentas</span>
        </button>
        <button
          onClick={() => navigate("/supervisora/reporte-supervisoras")}
          style={styles.button}
        >
          <img src="/images/mis-reportes.png" alt="Mis reportes" style={styles.image} />
          <span style={styles.label}>Mis reportes</span>
        </button>
        <button
          onClick={() => navigate("/supervisora/organizar-ruta-3")}
          style={{ ...styles.button, border: "2px solid #0891b2" }}
        >
          <span style={{ ...styles.image, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48 }}>🗓️</span>
          <span style={{ ...styles.label, color: "#0891b2" }}>Organizar Ruta 3</span>
        </button>
        <button
          onClick={() => navigate("/supervisora/cumpleanos")}
          style={{ ...styles.button, border: "2px solid #a855f7" }}
        >
          <span style={{ ...styles.image, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48 }}>🎂</span>
          <span style={{ ...styles.label, color: "#a855f7" }}>Cumpleaños</span>
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "40px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    minHeight: "100vh",
  },
  title: { marginBottom: "30px", color: "#333", marginTop: 60 },
  buttonContainer: { display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" },
  button: {
    width: "90%", maxWidth: "400px", padding: "20px",
    border: "2px solid #007bff", borderRadius: "10px",
    backgroundColor: "transparent", display: "flex",
    alignItems: "center", justifyContent: "center",
    gap: "20px", cursor: "pointer", transition: "all 0.2s ease-in-out",
  },
  image: { width: "80px", height: "80px", objectFit: "contain" },
  label: { fontSize: "20px", fontWeight: "bold", color: "#007bff", textAlign: "center" },
  btnVolver: {
    padding: "10px 22px", borderRadius: 20,
    background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
    color: "#fff", border: "none", cursor: "pointer",
    fontWeight: 700, fontSize: 15,
    boxShadow: "0 2px 8px rgba(29,78,216,0.35)",
  },
};

export default SupervisoraServicios;
